export const MILLISECONDS_PER_SECOND = 1000;
export const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export const INITIAL_COUNT = 0;
export const INITIAL_TOTAL = 0;

export const OVERDUE_THRESHOLD_MS = 7 * MILLISECONDS_PER_DAY;

export const CALLS_PAGE_SIZE = 100;
export const PROJECTS_PAGE_SIZE = 50;
export const DASHBOARD_LIST_LIMIT = 5;
